import * as React from "react";
function SvgRetweet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M3 25V13a8 8 0 018-8h12M19 1l4 4M19 9l4-4M29 7v12a8 8 0 01-8 8H9M13 31l-4-4M13 23l-4 4" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRetweet);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
